<!-- <ng-container *ngIf="!!get">
    <tt-tabs ttRememberId="w_workdetails.bg_tab1" [(ttSelectedId)]="get.bg_tab1" (ttSelectedIdChange)="onTabSelected($event)">
        <tt-tab ttId="EDIT" ttIcon="far fa-edit" ttLabel="edit_custact"></tt-tab>
        <tt-tab ttId="COMMENTS" ttIcon="far fa-comments-alt" ttLabel="custact_dialog"></tt-tab>
        <tt-tab ttId="EMAIL" ttIcon="far fa-envelope" ttLabel="customersmenu_email"></tt-tab>
        <tt-tab ttId="DOCUMENTS" ttIcon="far fa-file-alt" ttLabel="documents"></tt-tab>
        <tt-tab ttId="SUBTASKS" ttIcon="far fa-tasks" ttLabel="subtasks"></tt-tab>
        <tt-tab ttId="CUSTACTMEMBERS" ttIcon="far fa-users" ttLabel="participants"></tt-tab>
        <tt-tab ttId="POWTIMES" ttIcon="far fa-clock" ttLabel="workdetails_powtimes"></tt-tab>
        <tt-tab ttId="FUNCTIONS" ttIcon="far fa-ellipsis-h" ttLabel="bg_main_functions"></tt-tab>
    </tt-tabs>
    <tt-custact-edit #edit [hidden]="get.bg_tab1 !== 'EDIT'" [params]="{ custact_no: get.custact_no, filterfield: '-', filtervalue: '-' }" (submit)="onCustactSubmit(edit, dialogs)"></tt-custact-edit>
    <tt-custact-dialogs #dialogs [hidden]="get.bg_tab1 !== 'COMMENTS'" [params]="{ custact_no: get.custact_no }" (submit)="onCustactSubmit(edit, dialogs)"></tt-custact-dialogs>
    <tt-email-grid
        *ngIf="emailGridLoaded"
        [hidden]="get.bg_tab1 !== 'EMAIL'"
        rememberId="workdetails_email_grid"
        argType="custact_no"
        [argValue]="get.custact_no"
        webpage="workdetails"
    ></tt-email-grid>
    <tt-documents-grid
        *ngIf="documentsGridLoaded"
        [hidden]="get.bg_tab1 !== 'DOCUMENTS'"
        rememberId="documents_grid"
        [params]="{ argtype: 'custact_no', argvalue: get.custact_no, searchtext: '', doctype: 'd', onlyFilenames: '0' }"
    ></tt-documents-grid>
    <tt-grid *ngIf="subtasksGridLoaded" [hidden]="get.bg_tab1 !== 'SUBTASKS'" [(ttOptions)]="subtasksGrid"></tt-grid>
    <tt-grid *ngIf="participantsGridLoaded" [hidden]="get.bg_tab1 !== 'CUSTACTMEMBERS'" [(ttOptions)]="participantsGrid"></tt-grid>
    <tt-powtimes-grid
        *ngIf="powtimesGridLoaded"
        [hidden]="get.bg_tab1 !== 'POWTIMES'"
        ttRememberId="workdetails_powtimes_grid"
        [params]="{ businessco_no: '99999', date_fom: '1900-01-01', date_tom: '2200-12-31', custact_no: this.get.custact_no, webpage_name: 'workdetails' }"
    ></tt-powtimes-grid>
    <div [hidden]="get.bg_tab1 !== 'FUNCTIONS'">
        <tt-card class="col-md-3 col-xs-12 sp-2" ttHeading="work_details_group_register">
            <tt-work-details-register-functions [params]="get" (deleted)="navigator?.back()"></tt-work-details-register-functions>
        </tt-card>
        <tt-card class="col-md-3 col-xs-12 sp-2" ttHeading="work_details_group_plan">
            <tt-work-details-plan-functions [params]="get"></tt-work-details-plan-functions>
        </tt-card>
    </div>
</ng-container> -->
<ng-container *ngIf="!!get">
    <tt-work-details-desktop *ngIf="!('mobile' | mediaQuery)" [params]="get"></tt-work-details-desktop>
    <tt-work-details-mobile *ngIf="'mobile' | mediaQuery" [params]="get"></tt-work-details-mobile>
</ng-container>

<!-- <tt-card *ngIf="get.show_next_activity === '1'" class="col-md-3 col-xs-12 sp-2" ttHeading="work_details_group_plans">
    <ng-container [ngTemplateOutlet]="plansFunctions"></ng-container>
</tt-card> -->
<ng-template #planFunctions>
    <ng-container *ngIf="!!get">
        <tt-button-goto
            *ngIf="get.show_button_custactportalusers === '1'"
            ttText="participants"
            [ttBadge]="get.nbr_of_participants"
            ttGoto="custactmembers"
            [ttGotoParms]="{ custact_no: get.custact_no }"
        ></tt-button-goto>
        <tt-button-goto
            ttText="workdetails_custact_customer"
            [ttBadge]="get.nbr_of_custact_customer"
            ttGoto="custactcustomers"
            [ttGotoParms]="{ argtype: 'custact_no', argvalue: get.custact_no }"
        ></tt-button-goto>
        <tt-button-goto *ngIf="get.show_button_jobcalc === '1'" ttText="custact_calc" ttGoto="custactcalc" [ttGotoParms]="{ argtype: 'custact', argvalue: get.custact_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="get.show_button_custactplanning === '1'"
            ttText="activityplanning"
            ttGoto="custactplanning"
            [ttGotoParms]="{ argtype: 'custact_no', argvalue: get.custact_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="get.show_button_subtasks === '1'"
            ttText="subtasks"
            [ttBadge]="get.nbr_of_childs"
            ttGoto="subtasks"
            [ttGotoParms]="{ custact_no: get.custact_no, retrievetype: 'child', include_top: '0' }"
        ></tt-button-goto>
        <tt-button-goto *ngIf="get.show_button_gantt === '1'" ttText="custact_gantt" ttGoto="custactgantt" [ttGotoParms]="{ connectto: 'custact', connectto_value: get.custact_no }"></tt-button-goto>
        <tt-button-goto *ngIf="get.show_button_categoridatas === '1'" ttText="categorydata" ttGoto="categorydatas" [ttGotoParms]="{ argtype: 'custact', argvalue: get.custact_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="get.sum_salaryhours !== '0'"
            ttText="registered_previous"
            [ttBadge]="get.sum_salaryhours"
            ttGoto="powtimegroup"
            [ttGotoParms]="{
                cust_no: 0,
                project_keyno: 0,
                projectprosess_keyno: 0,
                custact_no: get.custact_no,
                date_start: get.min_date_start,
                date_end: get.max_date_end,
                grouptype: 'M',
                equipment_id: '-',
                labour_no: 0,
                prod_id: '-',
            }"
        ></tt-button-goto>
    </ng-container>
</ng-template>

<ng-template #plansFunctions>
    <ng-container *ngIf="!!get">
        <div class="col-xs-12 sp-0">
            <tt-button-goto
                class="col-xs-12 sp-0"
                ttText="subtask_add"
                tt-goto-func="vm.goTo"
                tt-goto-parms="'custactedit'"
                tt-icon="far fa-plus"
                tt-text-align="left"
                tt-icon-align="left"
            ></tt-button-goto>
            <tt-button-goto class="col-xs-12 sp-0" ttText="subtasks_add_excisting_activity" tt-goto-func="vm.goTo" tt-goto-parms="'custactsearch'" tt-text-align="left"></tt-button-goto>
            <tt-button
                class="col-xs-12 sp-0"
                ttText="subtasks_add_excisting_deviation"
                tt-click="vm.addExistingDeviationSubtask()"
                tt-type="link"
                tt-text-align="left"
                tt-icon="far fa-arrow-right"
                tt-icon-align="left"
            ></tt-button>
            <tt-button-goto
                ng-if="vm.model.work_details.show_button_gantt === '1'"
                class="col-xs-12 sp-0"
                ttText="custact_gantt"
                tt-goto-func="vm.goToCustactGantt"
                tt-text-align="left"
            ></tt-button-goto>
            <tt-button-settings ng-if="vm.model.work_details.show_setting === '1'" class="col-xs-12 sp-0"></tt-button-settings>
        </div>
    </ng-container>
</ng-template>
